
import Vue, { PropType } from 'vue'
import { PartnerServiceContract } from '@/types/generated/graphql'

type Props = {
  serviceContract: PartnerServiceContract
}

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    serviceContract: {
      type: Object as PropType<PartnerServiceContract>,
    },
  },
})
